let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l1o0A")).then(() => parcelRequire('4bg9b'));